import { Award, Sparkles, Leaf, Heart, Home as HomeIcon, Package } from 'lucide-react';

export default function ChiSiamo() {
  return (
    <main data-testid="chi-siamo-page">
      <section className="container-essenya py-20 max-w-3xl">
        <img
          src="https://customer-assets.emergentagent.com/job_14ecb35c-f142-4362-9aae-d32db27f4321/artifacts/htrzpywh_Essenya%20made%20italy.jpg%20%281%29.jpeg"
          alt="Essenya — Made in Italy"
          data-testid="chi-siamo-logo"
          className="w-44 md:w-52 h-auto mb-8 select-none mix-blend-multiply"
        />
        <div className="text-eyebrow mb-3">Chi siamo</div>
        <h1 className="font-display text-4xl md:text-6xl leading-[1.05] mb-6">La cura della casa diventa un gesto più bello.</h1>
        <p className="text-essenya-text text-lg leading-relaxed">Siamo un'azienda impegnata a offrire prodotti di alta qualità, selezionati con cura per garantire ai nostri clienti un'esperienza eccellente. La nostra missione è combinare affidabilità, attenzione ai dettagli e un servizio clienti sempre puntuale e dedicato. I nostri prodotti sono realizzati utilizzando estratti vegetali ottenuti dalle foglie di oltre 2000 specie di piante, un patrimonio naturale che ci permette di proporre soluzioni efficaci e innovative. Siamo in continua evoluzione, alla costante ricerca di miglioramenti e nuove soluzioni per rispondere al meglio alle esigenze dei nostri clienti.</p>
      </section>
      <section className="bg-essenya-surface2 py-20">
        <div className="container-essenya">
          <h2 className="font-display text-3xl md:text-4xl mb-10">I nostri valori</h2>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {[
              { I: Award, t: 'Qualità italiana', d: 'Formulato e prodotto in Italia con materie prime selezionate.' },
              { I: Sparkles, t: 'Profumazioni curate', d: 'Ogni fragranza è studiata per essere persistente, equilibrata, elegante.' },
              { I: Leaf, t: 'Cura dei dettagli', d: 'Dal packaging al gesto d\'uso, ogni elemento è pensato per piacere.' },
              { I: HomeIcon, t: 'Pulizia quotidiana', d: 'Prodotti pensati per essere usati ogni giorno, senza compromessi.' },
              { I: Heart, t: 'Affidabilità', d: 'Assistenza umana, ordini tracciati, resi semplici.' },
              { I: Package, t: 'Design essenziale', d: 'Estetica pulita, lineare, fatta per restare a vista in casa.' },
            ].map(({ I, t, d }, i) => (
              <div key={i} className="bg-white p-6 rounded-xl border border-essenya-border">
                <I size={22} strokeWidth={1.5} className="mb-4" />
                <p className="font-medium mb-1">{t}</p>
                <p className="text-essenya-text text-sm">{d}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
      <section className="container-essenya py-20 max-w-2xl text-center">
        <p className="font-display text-3xl md:text-4xl leading-snug">"Non vogliamo creare semplici prodotti per pulire. Vogliamo rendere più piacevole il modo in cui vivi la tua casa."</p>
      </section>
    </main>
  );
}
